import { getApi, patchApi, postApi, putApi } from "../apiCall";

export const handleCreateSchedule = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/createSchedule/${id}`;
  return getApi(url);
};

export const geScheduleDetails_Level1 = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/getAllByScheduleId?contractId=${id}&currentPage=0&size=100`;
  return getApi(url);
};

export const geScheduleDetails_Level2 = (repId) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/getAllByScheduleId?scheduleId=${repId}&currentPage=0&size=100`;
  return getApi(url);
};

export const editSchedule_data = (repId, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/blocks/scheduled/${repId}`;
  return putApi(url, payload);
};

export const deliverSchedule_data = (repId, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/blocks/delivered/${repId}`;
  return putApi(url, payload);
};

export const viewBlock = (repId) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/blocks/${repId}`;
  return getApi(url);
};

export const viewSettlement = ({
  id,
  connectionId,
  isForOneDay,
  repScheduleId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/break-down/${id}?connectionId=${connectionId}&repScheduleId=${repScheduleId}&isForOneDay=${isForOneDay}`;
  return getApi(url);
};

export const deliverStatusUpdate = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule`;
  return putApi(url, payload);
};

export const userFinalSettlement = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/final-settlement`;
  return postApi(url, payload);
};

export const finalSettlementMakerChecker = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/final-settlement`;
  return putApi(url, payload);
};

export const updateRepScheduleStatus = ({ id, status }) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/repSchedule/${id}?status=${status}`;
  return patchApi(url);
};

export const userFinalSettlementGet = ({ scheduleId, repScheduleId }) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/final-settlement?scheduleId=${scheduleId}&repScheduleId=${repScheduleId}`;
  return getApi(url);
};

export const schedulePayouts = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/pushTxnFile`;
  return postApi(url, payload);
};

export const generateNoca = () => {
  let url = `${process.env.REACT_APP_API_URL}/payments/pushTxnFile/noca/generate`;
  return getApi(url);
};
